import { useAuth } from 'prove-common'
import { useQuery } from '@tanstack/react-query'

export const useStatusDurationReport = (enabled = true) => {
  const { authFetch } = useAuth()
  return useQuery({
    queryKey: ['status-duration-report'],
    enabled,
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24,
    queryFn: async () => {
      const { data, error } = await authFetch().GET(
        '/dashboard/status-duration-report',
        {}
      )
      if (error) {
        throw new Error('Status duration report failed')
      }
      return data
    }
  })
}
